import {Controller} from "@hotwired/stimulus"
import TomSelect from "tom-select";
import {get} from "@rails/request.js";

// Connects to data-controller="tom-select--search"
export default class extends Controller {
    static values = {
        url: String,
        create: {
            type: Boolean,
            default: false
        },
        preload: {
            type: Boolean,
            default: false
        },
        plugins: {
            type: Array,
            default: ['remove_button']
        },
        maxItems: {
            type: Number,
            default: NaN
        },
        valueField: {
            type: String,
            default: 'id'
        },
        searchField: {
            type: Array,
            default: ['text']
        },
        sortField: {
            type: Array,
            default: [{field: '$score'}, {field: '$order'}]
        }
    }

    connect() {
        let config = {
            plugins: this.pluginsValue,
            create: this.createValue,
            valueField: this.valueFieldValue,
            selectOnTab: true,
            loadThrottle: 200,
            preload: this.preloadValue,
            maxItems: this.maxItemsValue,
            searchField: this.searchFieldValue,
            sortField: this.sortFieldValue,
            load: (q, callback) => this.search(q, callback)
        }
        this.tomSelect = new TomSelect(this.element, config)
    }

    disconnect() {
        this.tomSelect.destroy()
    }

    async search(q, callback) {

        const response = await get(this.urlValue, {
            query: {q: q},
            responseKind: 'json',
            headers: this.headers()
        });

        if (response.ok) {
            const list = await response.json
            this.tomSelect.clearOptions()
            callback(list)
        } else {
            callback()
        }
    }

    headers() {
        return {};
    }

}
